import axios from "axios";

const API = axios.create({
  baseURL: "/api",
});

// attach token
API.interceptors.request.use((req) => {
  const token = localStorage.getItem("token");
  if (token) req.headers.Authorization = `Bearer ${token}`;
  return req;
});


// ===============================
// CREATE ACTIVITY (POST /)
// ===============================
export const createActivityApi = (data) =>
  API.post("/lead-activities", data);


// ===============================
// GET MY ACTIVITY (GET /my)
// ===============================
export const getMyActivitiesApi = () =>
  API.get("/lead-activities/my");


// ===============================
// GET LEAD TIMELINE (GET /lead/:leadId)
// ===============================
export const getLeadActivitiesApi = (leadId) =>
  API.get(`/lead-activities/lead/${leadId}`);


// ===============================
// GET ALL ACTIVITIES (ADMIN ONLY GET /)
// ===============================
export const getAllActivitiesApi = () =>
  API.get("/lead-activities");